import "../../global/default.css";
import Card from "../Card/Card";
import { useTranslation } from "react-i18next";

// small or large card
type CardSize = "small" | "large";

export const SizeCard = ({ size, onClick }: { size: CardSize; onClick?: () => void }) => {
  const { t } = useTranslation();
  const isSmall = size === "small";

  return (
    <Card
      title={isSmall ? t("sizeChoice.sixInchesSevenFeet") : t("sizeChoice.sevenFeetSixtyTwoFeet")}
      size="lg"
      className="size-card"
      onClick={onClick}
    >
      {/* Title */}
      <div className="size-card-title">
        {isSmall ? t("sizeChoice.sixInchesSevenFeet") : t("sizeChoice.sevenFeetSixtyTwoFeet")}
      </div>

      {/* Grid Lines Background */}
      <div className="size-card-grid-background" />

      {/* Content with sharks and humans */}
      <div className="size-card-content">
        <div className="size-card-humans">
          <img
            src={`/HumanIcons/human-option_${isSmall ? "small" : "large"}.svg`}
            alt="human"
            className={`size-card-human size-card-human--${isSmall ? "small" : "large"}`}
            loading="lazy"
            decoding="async"
          />
        </div>

        <div className="size-card-sharks">
          {/* Large shark */}
          <img
            src={`/SharkIcons/shark-${size}-option_large.svg`}
            alt="shark large"
            className={`size-card-shark size-card-shark-large--${isSmall ? "small" : "large"}`}
            loading="lazy"
            decoding="async"
          />

          {/* Small shark */}
          <img
            src={`/SharkIcons/shark-${size}-option_small.svg`}
            alt="shark small"
            className={`size-card-shark size-card-shark-small--${isSmall ? "small" : "large"}`}
            loading="lazy"
            decoding="async"
          />
        </div>
      </div>
    </Card>
  );
};

export const SmallSizeCard = ({ onClick }: { onClick?: () => void }) => {
  return <SizeCard size="small" onClick={onClick} />;
};

export const LargeSizeCard = ({ onClick }: { onClick?: () => void }) => {
  return <SizeCard size="large" onClick={onClick} />;
};
